<script>
import { makeLogger } from "@/shared/consola";

const logger = makeLogger("PricingCreator.vue");
</script>

<script setup>
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import { ButtonPrimarySm } from "@easy/ui/buttons";
import { RocketIcon } from "@easy/ui/icons";
import VCreator from "@/shared/views/vCreator.vue";
import cCreatorStep from "@/shared/components/creator/cCreatorStep.vue";
import cCreatorThemes from "@/shared/components/creator/cCreatorThemes.vue";
import cCreatorLayouts from "@/shared/components/creator/cCreatorLayouts.vue";
//import cCreatorProduct from "@/shared/components/creator/cCreatorProduct.vue";
import { usePricingCreatorStore } from "@/apps/pricing/project/onboarding/pricing-creator.store";
import { pricingOnboardingService } from "@/apps/pricing/project/onboarding/pricing-onboarding.service";
import { useOnboardingVideo } from "@/shared/projects/onboarding/useOnboardingVideos";
import { CardSquare, CardsSquare } from "@easy/ui/cards";

const { locale } = useI18n();
const { video } = useOnboardingVideo("pricing");
const pricingCreatorStore = usePricingCreatorStore();
const { onboardState, previewCssVars, layouts, templates, previewComponent } =
    storeToRefs(pricingCreatorStore);
const { /*updateProductInfo,*/ toggleCreatorShown, onboardingAction } = pricingCreatorStore;

const generateOnboarding = onboardingAction(() => {
    logger.debug("send PRICING onboarding...", locale.value, onboardState.value);
    return pricingOnboardingService.sendOnboardData({
        ...onboardState.value,
        theme: onboardState.value.theme,
        lang: locale.value,
    });
});
</script>

<template>
    <VCreator
        :backColor="onboardState.theme?.colors?.background"
        :canSkipGenerator="!onboardState.isLoading"
        :description="$t('pricing.creator.subtitle')"
        :title="$t('pricing.creator.title')"
        :video="video"
        @close="toggleCreatorShown(false)"
    >
        <cCreatorStep
            :title="$t('pricing.creator.step_1_title')"
            :description="$t('pricing.creator.step_1_description')"
            :step="1"
        >
            <!--            <cCreatorProduct
                :error="onboardState.error"
                :hidePrompt="onboardState.hidePrompt"
                v-model:productSelectLater="onboardState.productSelectLater"
                @productInfoUpdated="updateProductInfo($event)"
            />-->
            <!-- EAS-2196 - temporary added -->
            <CardsSquare>
                <CardSquare
                    v-for="template in templates"
                    :key="template.id"
                    :title="template.value"
                    :is-selected="template.id === onboardState.template"
                    @click="
                        onboardState.template = template.id;
                        onboardState.promptDescription = `use:(${onboardState.template})`;
                    "
                >
                    <component class="w-6 h-6" :is="template.icon" />
                </CardSquare>
            </CardsSquare>
        </cCreatorStep>
        <cCreatorStep
            :title="$t('pricing.creator.step_2_title')"
            :description="$t('pricing.creator.step_2_description')"
            :step="2"
        >
            <cCreatorLayouts :variants="layouts" v-model="onboardState.layout" />
        </cCreatorStep>
        <cCreatorStep
            :title="$t('pricing.creator.step_3_title')"
            :description="$t('pricing.creator.step_3_description')"
            :step="3"
        >
            <cCreatorThemes v-model="onboardState.theme" />
        </cCreatorStep>
        <cCreatorStep
            :title="$t('pricing.creator.step_4_title')"
            :description="$t('pricing.creator.step_4_description')"
            :step="4"
            :last="true"
        >
            <ButtonPrimarySm @click="generateOnboarding()" :loading="onboardState.isLoading">
                <RocketIcon />
                <span>{{ $t("pricing.creator.step_4_cta") }}</span>
            </ButtonPrimarySm>
        </cCreatorStep>
        <template #preview>
            <div :style="{ ...previewCssVars }">
                <component :is="previewComponent" />
            </div>
        </template>
    </VCreator>
</template>
